import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { isAuthenticated, getUser } from "@/lib/auth";

import Home           from "@/pages/Home";
import FillSelector   from "@/pages/FillSelector";
import History        from "@/pages/History";
import Login          from "@/pages/Login";
import Admin          from "@/pages/Admin";
import TemperatureForm from "@/pages/forms/TemperatureForm";
import PestForm        from "@/pages/forms/PestForm";
import ReceptionForm   from "@/pages/forms/ReceptionForm";
import IncidenceForm   from "@/pages/forms/IncidenceForm";
import TrainingForm    from "@/pages/forms/TrainingForm";
import CleaningForm    from "@/pages/forms/CleaningForm";
import SheetList       from "@/pages/production/SheetList";
import SheetDetail     from "@/pages/production/SheetDetail";
import SheetEditor     from "@/pages/admin/SheetEditor";
import IngredientCatalog from "@/pages/admin/IngredientCatalog";
import ProviderCatalog  from "@/pages/admin/ProviderCatalog";
import AlbaranTemplates from "@/pages/admin/AlbaranTemplates";
import CleaningProducts from "@/pages/admin/CleaningProducts";
import AllergenMatrix   from "@/pages/production/AllergenMatrix";
import PlanList         from "@/pages/plans/PlanList";
import PlanDetail       from "@/pages/plans/PlanDetail";

function ProtectedRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  if (getUser()?.rol !== "admin") return <Navigate to="/" replace />;
  return children;
}

function FormSwitch() {
  const { type } = useParams();
  switch (type) {
    case "temperature": return <TemperatureForm />;
    case "pest":        return <PestForm />;
    case "reception":   return <ReceptionForm />;
    case "incidence":   return <IncidenceForm />;
    case "training":    return <TrainingForm />;
    case "cleaning":    return <CleaningForm />;
    default:            return <FillSelector />;
  }
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/fill" element={<ProtectedRoute><FillSelector /></ProtectedRoute>} />
          <Route path="/fill/:type" element={<ProtectedRoute><FormSwitch /></ProtectedRoute>} />
          <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
          <Route path="/production" element={<ProtectedRoute><SheetList /></ProtectedRoute>} />
          <Route path="/production/new" element={<AdminRoute><SheetEditor /></AdminRoute>} />
          <Route path="/production/:id" element={<ProtectedRoute><SheetDetail /></ProtectedRoute>} />
          <Route path="/production/:id/edit" element={<AdminRoute><SheetEditor /></AdminRoute>} />
          <Route path="/ingredients" element={<AdminRoute><IngredientCatalog /></AdminRoute>} />
          <Route path="/providers" element={<AdminRoute><ProviderCatalog /></AdminRoute>} />
          <Route path="/albaran-templates" element={<AdminRoute><AlbaranTemplates /></AdminRoute>} />
          <Route path="/cleaning-products" element={<ProtectedRoute><CleaningProducts /></ProtectedRoute>} />
          <Route path="/allergens" element={<ProtectedRoute><AllergenMatrix /></ProtectedRoute>} />
          <Route path="/plans" element={<ProtectedRoute><PlanList /></ProtectedRoute>} />
          <Route path="/plans/:number" element={<ProtectedRoute><PlanDetail /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" toastOptions={{ style: {
        background: "#1E120D", color: "#FDFBF7", border: "none",
        borderRadius: "12px", fontFamily: "Work Sans, sans-serif", fontWeight: 500,
      }}} />
    </div>
  );
}
